import axios from 'axios';
import vueTemp from "./vueTemp.js"

const service = axios.create({
  proxy: true,
  timeout: 10000,
  baseURL: getHomeUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

service.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem('token');
    if (token) {
      let tokenA = JSON.parse(token);
      config.headers.Authorization = tokenA.token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  });

service.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      window.location.href = "#/login";
    }
    if (error.response.status === 400) {
      vueTemp.$notify({title: '警告', message: error.response.data.errorMsg, type: 'warning'});
    }
    return Promise.reject(error)
  });

export default service



// WEBPACK FOOTER //
// ./src/common/home-request.js